// Projection of the adjustment list onto ONE editable column value in
// document form ("25 %", "120.50", chains joined with spaces). Display/input
// projection only — the discount ARITHMETIC lives in the extraction service.
import { Adjustment } from '../types/extraction-result';

export const isPercentAdjustment = (adjustment: Adjustment): boolean =>
  adjustment.kind === 'percent' || adjustment.kind === 'rate';

/** Canonical fraction ("0.25") → trimmed percent number string ("25"). */
export const fractionToPercentText = (value: string): string => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? String(+(parsed * 100).toFixed(6)) : value;
};

/**
 * Row adjustments as one column text. Cash discounts and interest hang on the
 * document root, not on a row — they don't belong into the column.
 */
export function discountsToColumn(adjustments: Adjustment[]): string {
  return adjustments
    .map((adjustment) => {
      if (!adjustment || adjustment.value == null || adjustment.value === '')
        return null;
      if (adjustment.category === 'cash_discount' || adjustment.category === 'interest')
        return null;
      if (isPercentAdjustment(adjustment))
        return `${fractionToPercentText(adjustment.value)} %`;
      return String(adjustment.value);
    })
    .filter((text) => text != null)
    .join(' ');
}

/** ISO-8601 duration → days ("P14D" → 14, "P2W" → 14; months → null). */
export function durationToDays(value: string | null | undefined): number | null {
  const text = String(value ?? '').trim();
  const match = /^P(\d+)([DWM])$/.exec(text);
  if (match)
    return match[2] === 'D' ? +match[1] : match[2] === 'W' ? +match[1] * 7 : null;
  return /^\d+$/.test(text) ? +text : null;
}
